import { getDefaultMRTOptions } from '@/modules/common/lib/react-material-table';
import { MaterialReactTable } from 'material-react-table';
import { EmployeeRow } from '../LearningBudgetSetupsTable.types';
import { createColumns } from './EmployeeTeamOverridesTable.columns';

interface EmployeeTeamOverridesTableProps {
  employeeOverrides: EmployeeRow[];
  onEdit: (row: EmployeeRow) => void;
  onDelete: (row: EmployeeRow) => void;
}

export const EmployeeTeamOverridesTable = ({
  employeeOverrides,
  onEdit,
  onDelete,
}: EmployeeTeamOverridesTableProps) => {
  const defaultTableOptions = getDefaultMRTOptions<EmployeeRow>();

  return (
    <MaterialReactTable
      {...defaultTableOptions}
      columns={createColumns(onEdit, onDelete)}
      enableTableHead={false}
      data={employeeOverrides}
      enableRowActions={false}
      enableRowSelection={false}
      enableColumnFilters={false}
      enableSorting={false}
      enableTopToolbar={false}
      muiTablePaperProps={{
        ...defaultTableOptions.muiTablePaperProps,
        classes: {
          root: 'bg-light-gray',
        },
      }}
      enablePagination={false}
      enableBottomToolbar={false}
      muiTableBodyCellProps={{
        ...defaultTableOptions.muiTableBodyCellProps,
        classes: {
          root: '!bg-transparent',
        },
        sx: { marginInline: 0, paddingInline: 4 },
      }}
      muiTableBodyRowProps={{
        ...defaultTableOptions.muiTableBodyRowProps,
        classes: {
          root: '!bg-transparent',
        },
      }}
    />
  );
};
